import type { SVGProps } from 'react'
const PlaceholderProduct = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={1000}
    height={500}
    viewBox="0 0 1000 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid slice"
    {...props}
  >
    <rect width={1000} height={500} fill="#EFEFF4" />
    <path
      d="M474.5 218.027C474.5 204.124 485.884 192.5 500 192.5C513.888 192.5 525.5 204.124 525.5 218.027V228.967H540.071C545.991 228.967 551 233.981 551 239.907V287.315C551 299.394 541.21 309.195 529.143 309.195H470.857C458.562 309.195 449 299.394 449 287.315V239.907C449 233.981 453.781 228.967 459.929 228.967H474.5V218.027ZM485.429 228.967H514.571V218.027C514.571 210.05 507.969 203.44 500 203.44C491.804 203.44 485.429 210.05 485.429 218.027V228.967ZM479.964 250.847C482.924 250.847 485.429 248.568 485.429 245.377C485.429 242.414 482.924 239.907 479.964 239.907C476.777 239.907 474.5 242.414 474.5 245.377C474.5 248.568 476.777 250.847 479.964 250.847ZM520.036 239.907C516.848 239.907 514.571 242.414 514.571 245.377C514.571 248.568 516.848 250.847 520.036 250.847C522.996 250.847 525.5 248.568 525.5 245.377C525.5 242.414 522.996 239.907 520.036 239.907Z"
      fill="#B2B2C1"
    />
  </svg>
)
export default PlaceholderProduct
